<template>
  <div class="field-picker">
    <div class="field-picker-title">ข้อมูลที่ต้องการเก็บจากผู้เข้าร่วม</div>
    <div class="field-row">
      <v-checkbox
        v-for="f in basicFields"
        :key="f.key + '-' + renderKey"
        :input-value="value"
        :value="f.key"
        :label="f.label"
        :disabled="f.required"
        color="primary"
        hide-details
        class="field-checkbox"
        @change="update"
      ></v-checkbox>
    </div>

    <template v-if="isAdmin">
      <div class="field-picker-subtitle">เฉพาะแอดมิน</div>
      <div class="field-row">
        <v-checkbox
          v-for="f in adminFields"
          :key="f.key"
          :input-value="value"
          :value="f.key"
          :label="f.label"
          color="primary"
          hide-details
          class="field-checkbox"
          @change="update"
        ></v-checkbox>
      </div>
    </template>

    <v-dialog :value="pendingSelection !== null" max-width="460" persistent>
      <v-card class="confirm-card">
        <v-card-title class="confirm-title">
          <v-icon color="secondary" class="mr-2">mdi-shield-alert</v-icon>
          ยืนยันการเก็บเลขบัตรประชาชน
        </v-card-title>
        <v-card-text class="confirm-text">
          โปรดพิจารณาความจำเป็นก่อนจัดเก็บ <b>สำเนาเลขบัตรประชาชน</b> และจัดเก็บเฉพาะกรณีที่จำเป็นต่อการดำเนินงานเท่านั้น
        </v-card-text>
        <v-card-actions class="confirm-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="cancelPid">ยกเลิก</v-btn>
          <v-btn color="primary" depressed @click="confirmPid">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { MEETING_FIELDS, withRequired } from '@/meetingFields';

export default {
  name: 'MeetingFieldPicker',
  props: {
    value: { type: Array, required: true },
    isAdmin: { type: Boolean, default: false },
  },
  data() {
    return {
      // รายการที่รอให้ยืนยันก่อน (ตอนเพิ่งติ๊กเลขบัตรประชาชน)
      pendingSelection: null,
      // เปลี่ยนค่าเพื่อให้ checkbox วาดใหม่ตาม value เมื่อกดยกเลิก
      renderKey: 0,
    };
  },
  computed: {
    basicFields() {
      return MEETING_FIELDS.filter(f => !f.adminOnly);
    },
    adminFields() {
      return MEETING_FIELDS.filter(f => f.adminOnly);
    },
  },
  methods: {
    update(selected) {
      // ข้อมูลบังคับ (ชื่อ-นามสกุล) ติดไปเสมอ และเรียงตามลำดับมาตรฐาน
      const next = withRequired(selected || []);
      const addingPid = next.indexOf('pid') !== -1 && this.value.indexOf('pid') === -1;
      if (addingPid) {
        this.pendingSelection = next;
        return;
      }
      this.$emit('input', next);
    },
    confirmPid() {
      this.$emit('input', this.pendingSelection);
      this.pendingSelection = null;
    },
    cancelPid() {
      this.pendingSelection = null;
      this.renderKey += 1;
    },
  },
};
</script>

<style scoped>
.field-picker {
  padding: 16px 20px;
  border: 1px solid #E8EDF3;
  border-radius: 12px;
  background-color: #FAFBFD;
}

.field-picker-title {
  color: #0C2F53;
  font-weight: 600;
  font-size: 16px;
}

.field-picker-subtitle {
  margin-top: 16px;
  color: #5B6B7F;
  font-size: 14px;
  font-weight: 600;
}

.field-row {
  display: flex;
  flex-wrap: wrap;
  column-gap: 32px;
}

.field-checkbox {
  margin-top: 8px;
}

.confirm-card {
  border-radius: 16px !important;
}

.confirm-title {
  color: #0C2F53;
  font-weight: 700;
}

.confirm-text {
  color: #3C4A5C !important;
  font-size: 15px;
  line-height: 1.6;
}

.confirm-actions {
  padding: 8px 16px 16px !important;
}
</style>
